export default {
  validationSummaryTitle: 'Data Template Validation Summary',
  close: 'Close',
  criticalErrorsTab: 'Critical Errors',
  warningsTab: 'Warnings',
  fileStructureErrors: 'File Structure Errors',
  columnWideDataErrors: 'Column-Wide Data Errors',
  rowSpecificDataErrors: 'Row-Specific Data Errors',
  cellSpecificDataErrors: 'Cell-Specific Data Errors',
  affectedRowsList: 'affected rows list',
  affectedCellsList: 'affected cells list',
  onlyFirst50: '(only first 50)',
  row: 'row',
  rows: 'rows',
  cell: 'cell',
  cells: 'cells',
  fileStructureWarnings: 'File Structure Warnings',
  columnWideDataWarnings: 'Column-Wide Data Warnings',
  rowSpecificDataWarnings: 'Row-Specific Data Warnings',
  uploadingFile: 'Uploading',
  cancel: 'Cancel',
  instructionsTitle: 'Data Upload Instructions',
  instructionsHeader: 'Instructions',
  instructionsIntro: 'In this section, you can upload the data required to train your marketing mix model. Follow these steps:',
  instructionsStep1: 'Download the provided Data Template spreadsheet.',
  instructionsStep2: 'Fill it out according to the instructions in the first two sheets.',
  instructionsStep3: 'Upload the completed spreadsheet, using the "Upload File" button.',
  instructionsValidation: 'The system will automatically validate the contents of your file. If it\'s valid, you\'ll see a',
  instructionsValidationContinue: 'under Validation Results, then a Data Scientist will manually review it and we\'ll let you know if have any further questions about the data.',
  instructionsIfFails: 'If the automatic validation fails, it means the system detected issues. You can click',
  summaryReport: 'Summary Report',
  instructionsReviewDetails: 'and review the issues in detail. There are two kinds of issues:',
  criticalErrorsDescription: 'prevent model training from taking place. You must correct them and re-upload the file.',
  warningsDescription: 'don\'t necessarily prevent model training from taking place, but you should carefully review them, fix anything that looks like a mistake, and re-upload the file. If you believe they\'re not mistakes, you can dismiss the warnings.',
  dataBriefsUploadTitle: 'Data Briefs Upload',
  dataBriefsCaption1: '1. This section allows uploading standard Brief documents with project requirements. Please download a copy',
  dataBriefsCaption1Link: 'here',
  dataBriefsCaption2: '2. These files will be reviewed by our team to understand your modeling requirements.',
  approvalStatus: 'Approval Status',
  pending: 'Pending',
  dataBriefHeader: 'Data Brief',
  uploadedOnHeader: 'Uploaded On',
  uploaderHeader: 'Uploader',
  actionsHeader: 'Actions',
  pleaseUploadDataBrief: 'Please upload your data brief',
  approveBrief: 'Approve Brief',
  uploadDataBrief: 'Upload Data Brief',
  dataTemplatesUploadTitle: 'Data Templates Upload',
  dataTemplatesCaption1: '1. This section only allows uploading standard data templates. Please download a copy',
  dataTemplatesCaption2: '2. Read the full instructions on how to use the uploader and interpret the results',
  dataFileHeader: 'Data File',
  validationResultsHeader: 'Validation Results',
  validatingFile: 'Validating file',
  noErrorsFound: 'No errors found',
  criticalError: 'critical error',
  criticalErrors: 'critical errors',
  warning: 'warning',
  warnings: 'warnings',
  fixErrorsFirst: 'Fix Errors First',
  approveData: 'Approve Data',
  pleaseUploadData: 'Please upload your data',
  uploadFile: 'Upload File',
  unsupportedFileType: 'Unsupported file MIME type',
  errorUploadingFile: 'Error uploading file.',
  dataCheckDialogTitle: 'Template approved. Want to check your data?',
  dataCheckDialogText: 'Data Check shows your template as simple charts, so you can spot missing periods, spikes or shifted dates before modeling starts.',
  dataCheckDialogLater: 'Later',
  dataCheckDialogGo: 'Go to Data Check'
}
